/* BL4CKOUT: <apx-delivery-date> for the cart Delivery & Trust block (snippets/apx-cart-trust.liquid).
   Loaded once from layout/theme.liquid on every page. It cannot live inline in the snippet: the cart
   drawer is only rendered when the cart has items, and when Horizon swaps in fresh drawer HTML after an
   add to cart, inline scripts inside it are never executed, so the element was never defined and the
   dates stayed empty. Defined globally, every inserted copy upgrades and fills its dates automatically. */
(function () {
  if (window.customElements && !customElements.get('apx-delivery-date')) {
    customElements.define('apx-delivery-date', class extends HTMLElement {
      connectedCallback() {
        this.render();
        /* Horizon morphs the drawer in place after cart changes: the element can stay connected while
           its contents are reset to the server's empty placeholders. Watch for that and refill. */
        if (!this._obs && window.MutationObserver) {
          var self = this;
          this._obs = new MutationObserver(function () { if (self.needsRender()) self.render(); });
          this._obs.observe(this, { childList: true, subtree: true, characterData: true });
        }
      }
      disconnectedCallback() { if (this._obs) { this._obs.disconnect(); this._obs = null; } }
      needsRender() {
        if (this.getAttribute('data-mode') === 'timeline') {
          var el = this.querySelector('[data-tl]');
          return !!el && el.textContent.trim() === '';
        }
        return /\[date/.test(this.getAttribute('data-template') || '') && !this.querySelector('strong');
      }
      addDays(from, n, business) {
        var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
        if (!business) { d.setDate(d.getDate() + n); return d; }
        var added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          var w = d.getDay();
          if (w !== 0 && w !== 6) added++;
        }
        return d;
      }
      opts(style) {
        return style === 'long' ? { weekday: 'long', month: 'long', day: 'numeric' }
          : style === 'date' ? { month: 'short', day: 'numeric' }
          : { weekday: 'short', month: 'short', day: 'numeric' };
      }
      fmt(d, style) {
        var lang = document.documentElement.lang || undefined;
        try { return new Intl.DateTimeFormat(lang, this.opts(style)).format(d); }
        catch (e) { return d.toDateString(); }
      }
      /* Timeline dates follow the same Date format setting as the text. */
      range(a, b, style) {
        var lang = document.documentElement.lang || undefined;
        var f;
        try { f = new Intl.DateTimeFormat(lang, this.opts(style)); } catch (e) { return a.toDateString(); }
        if (!b || b.getTime() === a.getTime()) return f.format(a);
        try { if (f.formatRange) return f.formatRange(a, b); } catch (e) {}
        return f.format(a) + ' to ' + f.format(b);
      }
      fill(tpl, a, b, style) {
        var out = tpl.replace(/\[date\]/g, '<strong>' + this.fmt(a, style) + '</strong>');
        if (b) return out.replace(/\[date_end\]/g, '<strong>' + this.fmt(b, style) + '</strong>');
        return out.replace(/\s*(and|to|-)?\s*\[date_end\]/g, '');
      }
      render() {
        var tpl = this.getAttribute('data-template') || '';
        var days = parseInt(this.getAttribute('data-days'), 10) || 0;
        var daysEnd = parseInt(this.getAttribute('data-days-end'), 10) || 0;
        var ship = parseInt(this.getAttribute('data-ship'), 10) || 0;
        var shipEnd = parseInt(this.getAttribute('data-ship-end'), 10) || 0;
        var business = this.getAttribute('data-business') === '1';
        var cutoff = parseInt(this.getAttribute('data-cutoff'), 10);
        var style = this.getAttribute('data-format') || 'short';
        var today = new Date();
        var now = new Date();
        /* After the cutoff hour (shopper's local time), the order counts from tomorrow. */
        if (!isNaN(cutoff) && cutoff < 24 && now.getHours() >= cutoff) now.setDate(now.getDate() + 1);
        var dStart = this.addDays(now, days, business);
        var dEnd = daysEnd > days ? this.addDays(now, daysEnd, business) : null;
        if (this.getAttribute('data-mode') !== 'timeline') {
          this.innerHTML = this.fill(tpl, dStart, dEnd, style);
          return;
        }
        var self = this;
        this.querySelectorAll('[data-tl-tpl]').forEach(function (el) {
          el.innerHTML = self.fill(el.getAttribute('data-tl-tpl'), dStart, dEnd, style);
        });
        var sStart = this.addDays(now, ship, business);
        var sEnd = shipEnd > ship ? this.addDays(now, shipEnd, business) : null;
        /* The compact one-row timeline always uses short dates (Oct 7): weekdays and long month names
           do not fit three steps on one row in the drawer. */
        var tl = this.closest('.apx-ct__tl--compact') ? 'date' : style;
        var set = function (k, txt) { var el = self.querySelector('[data-tl="' + k + '"]'); if (el) el.textContent = txt; };
        set('order', this.range(today, null, tl));
        set('ship', this.range(sStart, sEnd, tl));
        set('deliver', this.range(dStart, dEnd, tl));
      }
    });
  }
})();
/* Belt and braces: refill every estimate after any cart update. */
document.addEventListener('cart:update', function () {
  setTimeout(function () {
    document.querySelectorAll('apx-delivery-date').forEach(function (el) { if (el.render) el.render(); });
  }, 60);
});
